import script from "./createdevice_page.vue?vue&type=script&setup=true&lang=js"
export * from "./createdevice_page.vue?vue&type=script&setup=true&lang=js"

import "./createdevice_page.vue?vue&type=style&index=0&id=962e798c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-962e798c"]])

export default __exports__